// extracted by mini-css-extract-plugin
export default {"overlay":"sy-z","bodyOpen":"ty-z","content":"uy-z","header":"vy-z","close":"wy-z","closeNoHeading":"xy-z"};